/**
 * Choose readable text for a hex background by perceived luminance (YIQ).
 *
 * HubSpot option colors are often pale, so always-white text was unreadable on
 * them (#18844). Light backgrounds get dark ink; dark / saturated backgrounds
 * get white. Returns focused-view token vars. Malformed / non-6-digit hex falls
 * back to dark ink — the safe default on the light pill surfaces.
 */
export function readableInk(hexColor: string): string {
	const hex = hexColor.replace('#', '');
	if (hex.length !== 6) return 'var(--attr-ink)';
	const r = Number.parseInt(hex.slice(0, 2), 16);
	const g = Number.parseInt(hex.slice(2, 4), 16);
	const b = Number.parseInt(hex.slice(4, 6), 16);
	if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return 'var(--attr-ink)';
	const yiq = (r * 299 + g * 587 + b * 114) / 1000;
	return yiq >= 150 ? 'var(--attr-ink)' : 'var(--call-ink)';
}
